import { render, staticRenderFns } from "./CreatModal.vue?vue&type=template&id=01604d16&scoped=true"
import script from "./CreatModal.vue?vue&type=script&lang=ts"
export * from "./CreatModal.vue?vue&type=script&lang=ts"
import style0 from "./CreatModal.vue?vue&type=style&index=0&id=01604d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01604d16",
  null
  
)

export default component.exports